import Vue from "vue";
import store from "@/store";

export const ifNotAuthenticated = async (to, from, next) => {
  const currentUser = await fetchUser();

  if (!currentUser) {
    next();
    return;
  }
  next("/");
};

export const ifAuthenticated = async (to, from, next) => {
  const currentUser = await fetchUser();

  if (to.params.page) {
    let pages = store.getters["page/list"];
    if (!pages) {
      const { data } = await Vue.prototype.$api.Page.query();
      pages = data;
    }
    const page = pages.find(s => s.slug == to.params.page);
    store.commit("page/setActive", page);
  }

  if (currentUser) {
    next();
    return;
  }

  next(`/login`);
};

const fetchUser = async () => {
  return await store.dispatch("user/fetch");
};
